import React from 'react'
import PropertyField from '../PropertyField'

interface ObjectPropertyFieldProps {
	schema: Record<string, any>
	values?: Record<string, any>
	onChange: (updatedValues: Record<string, any>) => void
	sectionName?: string
	parentPropName?: string
  arrayIndex?: number
}

export default function ObjectPropertyField({ schema, values = {}, onChange, sectionName, parentPropName, arrayIndex }: ObjectPropertyFieldProps) {
	const handleChildChange = (propName: string, incoming: any) => {
		onChange({
			...values,
			[propName]: incoming,
		})
	}

	if (!schema || Object.keys(schema).length === 0) {
		return <div className="text-xs text-gray-500">Sem propriedades</div>
	}

	// Construir o sectionName completo combinando sectionName original com parentPropName
	// Isso garante que classes CSS sejam geradas corretamente para propriedades aninhadas
	// Exemplo: sectionName="our_story", parentPropName="button" -> "our_story_button"
	const fullSectionName = sectionName && parentPropName 
		? `${sectionName}_${parentPropName}`
		: sectionName || parentPropName

	return (
		<div className="space-y-2">
			{Object.entries(schema).map(([propName, propSchema]) => {
				const currentValue = (values as any)?.[propName]
				const propWithValue = { ...(propSchema as any), value: currentValue }
				return (
					<PropertyField
						key={propName}
						propName={propName}
						prop={propWithValue}
						sectionName={fullSectionName}
						arrayIndex={arrayIndex}
						onChange={(value) => handleChildChange(propName, value)}
					/>
				)
			})}
		</div>
	)
}


